import React from 'react';
import { Link } from 'react-router-dom';
import './sub.css';
import contactConfig from "../confi";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column">
              <div className="footer-logo">
                <h3>JP Home Service</h3>
                <p>Professional house help services across India</p>
              </div>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <div>
                    <p>Call Us</p>
                    <a
                      href={`tel:${contactConfig.phone}`}
                      className="cta-btn1 secondary23 assistant-btn"
                      onClick={() => {
                        return window.gtag_report_conversion
                          ? window.gtag_report_conversion(`tel:${contactConfig.phone}`)
                          : true;
                      }}
                    >
                      {contactConfig.phone}
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <div>
                    <p>Call Us</p>
                    <a
                      href={`tel:${contactConfig.phone1}`}
                      className="cta-btn1 secondary23 assistant-btn"
                      onClick={() => {
                        return window.gtag_report_conversion
                          ? window.gtag_report_conversion(`tel:${contactConfig.phone1}`)
                          : true;
                      }}
                    >
                      {contactConfig.phone1}
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📧</span>
                  <div>
                    <p>Email Us</p>
                    <a href={`mailto:${contactConfig.email}`}>{contactConfig.email}</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-column">
              <h3>Our Services</h3>
              <ul>
                <li><Link to="/house-maid-services-in-ahmedabad">House Maid</Link></li>
                <li><Link to="/cook-services-in-ahmedabad">Cook</Link></li>
                <li><Link to="/baby-sitting-services-in-ahmedabad">Baby Sitting</Link></li>
                <li><Link to="/elder-care-services-in-ahmedabad">Elderly Care</Link></li>
                <li><Link to="/driver-services-in-ahmedabad">Driver</Link></li>
                <li><Link to="/patient-care-services-in-ahmedabad">Patient Care</Link></li>
                <li><Link to="/office-boy-services-in-ahmedabad">Office Boy</Link></li>
                <li><Link to="/servant-services-in-ahmedabad-24-hours">24x7 Servant</Link></li>
              </ul>
            </div>

            <div className="footer-column1">
              <h3>Services</h3>
              <ul>
                <li><Link to="/house-maid-services-in-ahmedabad">Best House Maid Services in Ahmedabad</Link></li>
                <li><Link to="/cook-services-in-ahmedabad">Best Cook Services in Ahmedabad</Link></li>
                <li><Link to="/baby-sitting-services-in-ahmedabad">Best Baby Sitting Services in Ahmedabad</Link></li>
                <li><Link to="/elder-care-services-in-ahmedabad">Best Elder Care Services in Ahmedabad</Link></li>
              </ul>
              <ul>
                <li><Link to="/driver-services-in-ahmedabad">Best Driver Services in Ahmedabad</Link></li>
                <li><Link to="/patient-care-services-in-ahmedabad">Best Patient Care Services in Ahmedabad</Link></li>
                <li><Link to="/office-boy-services-in-ahmedabad">Best Office Boy Services in Ahmedabad</Link></li>
                <li><Link to="/servant-services-in-ahmedabad-24-hours">Best 24x7 Servant Services in Ahmedabad</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/aboutus">About Us</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Cities We Serve</h3>
              <div className="cities-list">
                <div className="city-group">
                  <a href="/contact">Ahmedabad</a>
                  <a href="/contact">Vadodara</a>
                </div>
                <div className="city-group">
                  <a href="/contact">Surat</a>
                  <a href="/contact">Rajkot</a>
                </div>
                <div className="city-group">
                  <a href="/contact">Vapi</a>
                  <a href="/contact">Gandhinager</a>
                </div>
                <div className="city-group">
                  <a href="/contact">Bhavnagar</a>
                  <a href="/contact">Udaipur</a>
                </div>
                <div className="city-group">
                  <a href="/contact">Mehsana</a>
                  <a href="/contact">Mumbai</a>
                </div>
                <div className="city-group">
                  <a href="/contact">Bangalore</a>
                </div>
              </div>

              <div className="social-links">
                <h4>Follow Us</h4>
                <div className="social-icons">
                  <a href="https://www.facebook.com/jphomeservice.in/" className="social-link" aria-label="Facebook">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                  <a href="https://www.instagram.com/jp_home_service/" className="social-link" aria-label="Instagram">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/company/j-p-home-services/" className="social-link" aria-label="LinkedIn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                  </a>
                  <a href="https://twitter.com/" className="social-link" aria-label="Twitter">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <p>&copy; 2026 JP Home Services. All Rights Reserved. Powered by Sumit DevTech.</p>
            <div className="footer-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-conditions">Terms & Conditions</Link>
              {/* <a href="/sitemap.xml">Sitemap</a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;